module.exports = __webpack_public_path__ + "img/challenge.8528e750.png";